import React from 'react'
import Link from 'gatsby-link'

import Fill from '../../images/Fill.svg'

const BlogSidebar = () => (
  <div>
    <div className='blog-sidebar'>
      <h1 className='smallerHone'>Latest Posts</h1>
      <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/><br/>
      <Link to="/blog/digital-marketing-why-and-how-it-is-your-smartest-move/" className='slide'>Digital Marketing: Why and how it is your Smartest Move</Link><br/>
      <Link to="/blog/why-is-content-marketing-important/" className='slide'>Why is Content Marketing important?</Link><br/>
      <Link to="/blog/why-is-it-important-to-market-your-business-digitally/" className='slide'>Why is it important to market your business digitally?</Link>
    </div>
  </div>
)

export default BlogSidebar



// WEBPACK FOOTER //
// ./src/components/BlogSidebar/index.js